import React from 'react';
import { Card, CardBody, CardHeader, Col, Container, Row } from 'reactstrap';
import { Breadcrumbs, H5, } from '../../../AbstractElements';
import { DescriptionIndividualColumn, IndividualColumn } from '../../../Constant';
import ProductDataTable from './ProductDataTable';

const ProductListContainer = () => {
  return (
    <>
      <Container fluid={true} className='list-products'>
        <Breadcrumbs justify='end' pageTitle='Product List' parent='Ecommerce' title='Product List' />
        <Row>
          <Col>
            <Card>
              <CardHeader className='pb-0'>
                <H5>{IndividualColumn}</H5>
                <span>{DescriptionIndividualColumn}</span>
              </CardHeader>
              <CardBody>
                <ProductDataTable />
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </>
  );
};
export default ProductListContainer;
